export enum PageActions {
    OrderDetailChange,
    PageChange,
    RowsPerPageChange,
    PageActions,
}
